import knapsackGoods from './knapsackGoods'
import knapsackUserGoods from './knapsackUserGoods'

const state = {
}

const getters = {
}

const mutations = {
}

const actions = {
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
  modules: {
    knapsackGoods,
    knapsackUserGoods,
  }
}
